export { SCOPES } from "@sentry/mcp-core/scopes";

export const NPM_PACKAGE_NAME = "@sentry/mcp-server";
